/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { getUserCashboxes } from "@/requests/general";
import { Cashbox } from "@/models/api/Cashbox";

export interface CashboxesStateInterface {
  userCashboxes: null | Array<Cashbox>;
}

export const CashboxesState: CashboxesStateInterface = {
  userCashboxes: null,
};

const CashboxesModule = defineModule({
  state: CashboxesState as CashboxesStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setUserCashboxes(state, param: Array<Cashbox>) {
      state.userCashboxes = param;
    },
  },
  actions: {
    async downloadUserCashboxes(context) {
      const { commit } = _moduleActionContext(context);
      const response = await getUserCashboxes();
      commit.setUserCashboxes(response);
    },
    async getDefaultUserCashbox(context): Promise<Cashbox | null> {
      const { dispatch, state } = _moduleActionContext(context);
      await dispatch.downloadUserCashboxes();
      if (state.userCashboxes !== null) return state.userCashboxes.find((v) => v.isSelected) ?? null;
      return null;
    },
  },
});

export default CashboxesModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, CashboxesModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, CashboxesModule);
